import Chyron from './Chyron';
import useStylesChyronPreview from './styles/useStylesChyronPreview';

const ChyronPreview = ({ asset }) => {
    const { classes } = useStylesChyronPreview();

    return (
        <div className={classes.chyron}>
            <div className={classes.chyronContent}>
                <Chyron
                    snippets={asset.text.replace(/\r/g, '').split(/\n/)}
                    color={asset.color}
                    size="small"
                    speed={8000}
                    uppercase={true}
                />
            </div>
        </div>
    );
};

export default ChyronPreview;
